export enum FILTER_TEMPLATES_BUS_ACTIONS {
  SAVE_FILTERS = "FILTER_TEMPLATES_BUS_ACTIONS.SAVE_FILTERS",
  RESTORE_FILTER = "FILTER_TEMPLATES_BUS_ACTIONS.RESTORE_FILTER",
  DELETE_TEMPLATE = "FILTER_TEMPLATES_BUS_ACTIONS.DELETE_TEMPLATE",
}
